/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import ICButton from "../../components/button";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import ICCheckbox from "../../components/form/checkbox";
import Label from "../../components/label";
import moment from "moment";
import APP_CONSTANTS from "./../../constants";
import Model from "../../components/modal";
import momentTz from "moment-timezone";
import appRoutes from "../../routes/appRoutes";
import { useHistory } from "react-router-dom";
import Popover from "@material-ui/core/Popover";
import InfoIcon from "./../../assets/images/info.png";
import CustomModal from "../../components/modal";
import { UncontrolledTooltip } from "reactstrap";
import TextField from "@material-ui/core/TextField";

const TicketsUpdateForm = props => {
  const [accessLogModelDoctor, setAccessLogModelDoctor] = useState(false);
  const [notifyDoctorModel, setNotifyDoctorModel] = useState(false);
  const [notifyDoctorSuccessModel, setNotifyDoctorSuccessModel] = useState(false);
  const [accessLogModelPatient, setAccessLogModelPatient] = useState(false);
  const history = useHistory();
  const [doctorNotifiedModelBody, setDoctorNotifiedModelBody] = useState(null);
  const [doctorActionModelBody, setDoctorActionModelBody] = useState(null);
  const [notifyDoctorModelBody, setNotifyDoctorModelBody] = useState(`
    <div>
      <p className="text-center mb-0">Notification Successfully Sent</p>
    </div>
  `);
  // const [doctorNotifiedModelBody, setDoctorNotifiedModelBody] = useState(null);
  const [disableNotifyPatient, setDisableNotifyPatient] = useState(false);
  const [anchorElement, setAnchorElement] = useState(null);
  const [patientNotifiedModelBody, setPatientNotifiedModelBody] = useState(
    null
  );
  const [initialDoctorNotes, setInitialDoctorNotes] = useState("");
  const [isDoctorNotesChanged, setIsDoctorNotesChanged] = useState(false);
  const [nilActionRequired, setNilActionRequired] = useState(false);
  const [followUpRequired, setFollowUpRequired] = useState(false);
  const [disableButton, setDisableButton] = useState({});
  const [doctorNotes, setDoctorNotes] = useState([])
  const [fields, setFields] = useState([[{ id: '', message: "" }]])
  const [message, setMessage] = useState('')
  // For attachment files, however, we have removed this functionality
  // const [attachmentFile, setattachmentFile] = useState(props.ticketData ? props.ticketData.attachments : []);

  /*
   * Props are passing ticket data and filling here. Just doctor notes is editable and pass the same object on edit
   */
  const formik = useFormik({
    initialValues: {
      ticketNo: props.ticketData ? props.ticketData.caseNumber : "-",
      dateReceived: props.ticketData
        ? moment(props.ticketData.dateReceived).format("DD-MM-YYYY")
        : "-",
      doctorName: props.ticketData
        ? "UIN:" +
        props.ticketData.doctorId.doctorId +
        " | " +
        props.ticketData.doctorId.firstName +
        " " +
        props.ticketData.doctorId.lastName
        : "-",
      ticketStatus: props.ticketData
        ? props.ticketData.status === "IN_PROGRESS"
          ? "In Progress"
          : props.ticketData.status === "OPEN"
            ? "Unopened"
            : props.ticketData.status === "ON_HOLD"
              ? "On Hold"
              : props.ticketData.status === "RESOLVED"
                ? "Resolved"
                : props.ticketData.status === "DOCTOR_ACTION_REQUIRED"
                  ? "Doctor Action Required"
                  : props.ticketData.status === "ADMIN_ACTION_REQUIRED"
                    ? "Support Action Required"
                    : "Reopened"
        : "-",
      onHoldDate: props.ticketData
        ? props.ticketData.onHoldDate
          ? moment(props.ticketData.onHoldDate).format("DD-MM-YYYY")
          : ""
        : "-",
      patientName: props.ticketData
        ? "UIN: " +
        props.ticketData.patientId.patientId +
        " | " +
        props.ticketData.patientId.firstName +
        " " +
        props.ticketData.patientId.lastName
        : "-",
      responsiblePerson: props.ticketData
        ? props.ticketData.responsible.firstName +
        " " +
        props.ticketData.responsible.lastName
        : "-",
      ticketSubject: props.ticketData ? props.ticketData.subject : "-",
      notes: props.ticketData ? props.ticketData.message : "-",
      doctorNotes: props.ticketData
        ? props.ticketData.doctorNotes.map((item, index) => ({
          actionLogs: item.actionLogs,
          doctorId: item.doctorId,
          doctorName: "Dr. " + (props.ticketData.doctorId ? props.ticketData.doctorId.firstName : '') + ' ' + (props.ticketData.doctorId ? props.ticketData.doctorId.lastName : ''),
          createdAt: item.createdAt,
          note: item.note,
          status: item.status,
          id: item._id,
        }))
        : [],
      adminNotes: props.ticketData
        ? props.ticketData.adminNotes.map((item, index) => ({
          id: item._id,
          createdAt: item.createdAt,
          adminName: (item.adminId ? item.adminId.firstName : '') + ' ' + (item.adminId ? item.adminId.lastName : ''),
          message: item.note,
        }))
        : [],
      message: '',
      refusedTests: props.ticketData?.refusedTests,
      resultsReceived: props.ticketData?.resultsReceived,
      requestedTests: props.ticketData?.requestedTests
    },
    validationSchema: Yup.object({}),
    enableReinitialize: true, // used for re initialize the formik when values are available
    onSubmit: values => {
      props.onFormSubmit(values, isDoctorNotesChanged); // submit props here
    }
  });
  console.log(formik)
  const goToPatientPMSPortal = () => {
    const auth = props.userData;
    const patientData = props.ticketData.patientId;
    window.open(
      APP_CONSTANTS.pmsURL +
      "/patient/patientDetails?accessToken=" +
      auth.accessToken +
      "&patientId=" +
      patientData._id +
      "&searchType=DOCTOR" +
      "&adminName=" +
      patientData.firstName +
      " " +
      patientData.lastName,
      "_blank"
    );
  };

  const handleNotifyDoctor = (formik, title) => {
    let data = formik.values;
    data.dateReceived = props.ticketData.dateReceived
    let tStatus = "DOCTOR_ACTION_REQUIRED"
    if (title === "Mark as Resolved") {
      setNotifyDoctorModelBody(`
    <div>
      <p className="text-center mb-0">Marked as Resolved Successfully</p>
    </div>
  `);
      tStatus = "RESOLVED"
    }
    props.notifySupportSubmit(formik.values, tStatus, isDoctorNotesChanged);
    setDisableButton(true)
    setNotifyDoctorSuccessModel(true)
  };

  const handleadminaction = (notes, id, title) => {
    const tickitid = props.ticketData._id
    // let tStatus = "DOCTOR_ACTION"
    console.log("titleeee", title);
    if (title === "Mark as Resolved") {
      setNotifyDoctorModelBody(`
    <div>
      <p className="text-center mb-0">Support Team Notified Successfully</p>
    </div>
  `);
      props.resolvedadminAction(tickitid, id);
      // tStatus = "RESOLVED"
    }
    if (title === "Notify Support") {
      props.markadminAction(tickitid, notes, id);
      setDisableButton((prevState) => ({
        ...prevState,
        [id]: true,
      }));
    }
    setNotifyDoctorSuccessModel(true)
  }

  const handleChangenotes = (e) => {
    const { value } = e.target;
    setMessage(e.target.value);
    // const updatedDoctorNotes = [{ note: value }];
    formik.setFieldValue("message", value);
  }

  const handleAddNotes = () => {
    const tickitid = props.ticketData._id
    props.addNotes(tickitid, message, followUpRequired, nilActionRequired);
    setMessage('');
  }

  const getButtonProperties = (status, disableButton) => {
    const isAdminAction = status === "ADMIN_ACTION_REQUIRED";
    const isDoctorAction = status === "DOCTOR_ACTION_REQUIRED";
    const isResolved = status === "RESOLVED";

    // Disable the button if the status is resolved, doctor action, or explicitly disabled
    const disabled = /* isDoctorAction || */ isResolved || disableButton;

    // Class name changes based on status
    const className = isResolved
      ? "float-left gray"
      : isDoctorAction
        ? "float-left green"
        : isAdminAction
          ? "float-left"
          : disabled
            ? "float-left gray"
            : "float-left";

    // Title changes based on status
    const title = isResolved
      ? "Marked as Resolved"
      : isDoctorAction
        ? "Mark as Resolved"
        : isAdminAction
          ? "Support Notified"
          : "Notify Support";

    return { disabled, className, title };
  };

  // const { disabled, className, title } = getButtonProperties(
  //   props.ticketData?.status,
  //   disableButton
  // );

  const handleCheckboxChange = (index, checkboxType) => {
    const updatedDoctorNotes = [...formik.values.doctorNotes];
    let note = updatedDoctorNotes[index];
    let newDoctorNotes = note.note ? note.note.trim() : message ? message : '';
    // let newDoctorNotes = formik.values.doctorNotes ? formik.values.doctorNotes.trim() : "";

    // Remove existing "Nil Action Required" or "Follow-Up Required" lines
    newDoctorNotes = newDoctorNotes
      .split("\n")
      .filter(line => line !== "Nil Action Required" && line !== "Follow-Up Required")
      .join("\n");

    // Toggle the selection
    if (checkboxType === "NilActionRequired") {

      if (nilActionRequired) {
        setNilActionRequired(false); // Uncheck
      } else {
        setNilActionRequired(true); // Check
        setFollowUpRequired(false); // Uncheck the other checkbox
        newDoctorNotes = newDoctorNotes + (newDoctorNotes ? "\n" : "") + "Nil Action Required";
      }
    } else if (checkboxType === "FollowUpRequired") {
      if (followUpRequired) {
        setFollowUpRequired(false); // Uncheck
      } else {
        setFollowUpRequired(true); // Check
        setNilActionRequired(false); // Uncheck the other checkbox
        newDoctorNotes = newDoctorNotes + (newDoctorNotes ? "\n" : "") + "Follow-Up Required";
      }
    }

    updatedDoctorNotes[index] = {
      ...note,
      note: newDoctorNotes,
    };

    formik.setFieldValue("doctorNotes", updatedDoctorNotes);
  };

  const handleCheckboxChange_1 = (checkboxType) => {
    let newDoctorNotes = formik.values.message ? formik.values.message.trim() : "";

    // Remove existing "Nil Action Required" or "Follow-Up Required" lines
    newDoctorNotes = newDoctorNotes
      .split("\n")
      .filter(line => line !== "Nil Action Required" && line !== "Follow-Up Required")
      .join("\n");

    // Toggle the selection
    if (checkboxType === "NilActionRequired") {

      if (nilActionRequired) {
        setNilActionRequired(false); // Uncheck
      } else {
        setNilActionRequired(true); // Check
        setFollowUpRequired(false); // Uncheck the other checkbox
        newDoctorNotes = newDoctorNotes + (newDoctorNotes ? "\n" : "") + "Nil Action Required";
      }
    } else if (checkboxType === "FollowUpRequired") {
      if (followUpRequired) {
        setFollowUpRequired(false); // Uncheck
      } else {
        setFollowUpRequired(true); // Check
        setNilActionRequired(false); // Uncheck the other checkbox
        newDoctorNotes = newDoctorNotes + (newDoctorNotes ? "\n" : "") + "Follow-Up Required";
      }
    }
    setMessage(newDoctorNotes)
    formik.setFieldValue("message", newDoctorNotes);
  };

  const closeAccessLogModel = () => {
    setAccessLogModelDoctor(false);
    setAccessLogModelPatient(false);
  };

  const closeNotifyDoctorModel = () => {
    setNotifyDoctorModel(false);
    setNotifyDoctorSuccessModel(false);
  };

  const handleActionLogs = (actionLogs) => {
    let newContent = ""
    if (
      actionLogs && actionLogs.length
    ) {
      actionLogs.map((value, index) => {
        console.log("Value here: ", value);
        let sentNotificationBy = "-";

        if (value.doctorId?.firstName && value.doctorId?.lastName) {
          sentNotificationBy =
            value.doctorId.firstName === "System" || value.doctorId.lastName === "System"
              ? "Instant Consult"
              : `Dr. ${value.doctorId.firstName} ${value.doctorId.lastName}`; // Add Dr. prefix for doctors
        } else if (value.adminId?.firstName && value.adminId?.lastName) {
          sentNotificationBy =
            value.adminId.firstName === "System" || value.adminId.lastName === "System"
              ? "Automated | Instant Consult"
              : `${value.adminId.firstName} ${value.adminId.lastName}`;
        }

        let notificationText;
        const status = value.extras.status;
        if (status === "ADMIN_ACTION_REQUIRED") {
          notificationText = `Support Team Notified`;
        } else if (status === "DOCTOR_ACTION_REQUIRED") {
          notificationText = `Marked As Actioned`;
        } else if (status === "RESOLVED") {
          notificationText = `Marked As Resolved`;
        } else {
          notificationText = `Other Action`;
        }

        newContent += `
          <div title="${notificationText}" key=${index} class="row p-0 m-0 text-left">
            <div class="col-sm-12">
              <span class="text-success mr-1"><i class="fas fa-check"></i></span>
              <span>${momentTz(value.createdAt)
            .tz("Australia/Brisbane")
            .format("DD-MM-YYYY hh:mm A")}</span>
              <span class="ml-3">${sentNotificationBy}</span>
            </div>
          </div>
        `;
      });
    } else {
      newContent += `
        <div class="row p-0 m-0">
          <div class="col-sm-12">
            <span>No data found</span>
          </div>
        </div>
      `;
    }
    setDoctorActionModelBody(newContent);
    setNotifyDoctorModel(true);
  }

  useEffect(() => {
    let content = "",
      patientModelContent = "";
    let newContent = "";

    let responsiblePersonName = '-';
    if (props.ticketData && props.ticketData.responsible && props.ticketData.responsible.firstName && props.ticketData.responsible.lastName) {
      if (props.ticketData.responsible.firstName === "System" || props.ticketData.responsible.lastName === "System") {
        responsiblePersonName = 'Automated | Instant Consult'
      } else {
        responsiblePersonName = `${props.ticketData.responsible.firstName} ${props.ticketData.responsible.lastName}`
      }
      formik.setFieldValue('responsiblePerson', responsiblePersonName);
    }

    if (
      props.ticketData &&
      props.ticketData.doctorNotifiedBy &&
      props.ticketData.doctorNotifiedBy.length
    ) {
      // setDoctorNotifiedData(props.ticketData.doctorNotifiedBy);
      props.ticketData.doctorNotifiedBy.map((value, index) => {
        // console.log(value);
        let sentNotificationBy = '-';
        if (value.adminId.firstName && value.adminId.lastName) {
          if (value.adminId.firstName === "System" || value.adminId.lastName === "System") {
            sentNotificationBy = 'Instant Consult'
          } else {
            sentNotificationBy = `${value.adminId.firstName} ${value.adminId.lastName}`
          }
        }

        content += `
            <div class="row p-0 m-0 text-left">
              <div class="col-sm-12">
                <span class="text-success mr-1"><i class="fas fa-check"></i></span>
                <span>${momentTz(value.accessDate)
            .tz("Australia/Brisbane")
            .format("DD-MM-YYYY hh:mm A")}</span>
                <span class="ml-3">${sentNotificationBy}</span>
              </div>
            </div>
          `;
      });
    } else {
      content += `
          <div class="row p-0 m-0">
            <div class="col-sm-12">
              <span>No data found</span>
            </div>
          </div>
      `;
    }
    if (
      props.ticketData &&
      props.ticketData.patientNotifiedBy &&
      props.ticketData.patientNotifiedBy.length
    ) {
      props.ticketData.patientNotifiedBy.map((value, index) => {
        console.log(value);
        let sentNotificationBy = '-';
        if (value.adminId.firstName && value.adminId.lastName) {
          if (value.adminId.firstName === "System" || value.adminId.lastName === "System") {
            sentNotificationBy = 'Automated | Instant Consult'
          } else {
            sentNotificationBy = `${value.adminId.firstName} ${value.adminId.lastName}`
          }
        }
        patientModelContent += `
            <div class="row p-0 m-0 text-left">
              <div class="col-sm-12">
                <span class="text-success mr-1"><i class="fas fa-check"></i></span>
                <span>${momentTz(value.accessDate)
            .tz("Australia/Brisbane")
            .format("DD-MM-YYYY hh:mm A")}</span>
                <span class="ml-3">${sentNotificationBy}</span>
              </div>
            </div>
          `;
      });
    } else {
      patientModelContent += `
          <div class="row p-0 m-0">
            <div class="col-sm-12">
              <span>No data found</span>
            </div>
          </div>
      `;
    }

    if (
      props.ticketData &&
      props.ticketData.adminNotes &&
      props.ticketData.adminNotes.length
    ) {
      const notes = props.ticketData.adminNotes && props.ticketData.adminNotes.map((item, index) => ({
        id: item._id,
        createdAt: item.createdAt,
        adminName: (item.adminId ? item.adminId.firstName : '') + ' ' + (item.adminId ? item.adminId.lastName : ''),
        message: item.note,
      }))
      setFields(notes);
    }

    if (
      props.ticketData &&
      props.ticketData.doctorNotes &&
      props.ticketData.doctorNotes.length
    ) {
      const doctorNotes = props.ticketData.doctorNotes && props.ticketData.doctorNotes.map((item, index) => ({
        actionLogs: item.actionLogs,
        doctorId: item.doctorId,
        doctorName: "Dr. " + (props.ticketData.doctorId ? props.ticketData.doctorId.firstName : '') + ' ' + (props.ticketData.doctorId ? props.ticketData.doctorId.lastName : ''),
        createdAt: item.createdAt,
        note: item.note,
        status: item.status,
        id: item._id,
      }))
      setDoctorNotes(doctorNotes);
    }


    setDoctorNotifiedModelBody(content);
    setDoctorActionModelBody(newContent);
    setPatientNotifiedModelBody(patientModelContent);
  }, [props.ticketData]);

  /*
   * Below code was for attachment files, however, we have removed this functionality.
   */
  // useEffect(() => {
  //   console.log(props.ticketData);
  //   if (props.ticketData)
  //     setattachmentFile(props.ticketData.attachments);
  // }, [props.ticketData]);

  useEffect(() => {

  }, []);

  useEffect(() => {
    if (props.ticketData?.doctorNotes && !initialDoctorNotes) {
      setInitialDoctorNotes(props.ticketData.doctorNotes);
    }
  }, [props.ticketData, initialDoctorNotes]);

  useEffect(() => {
    if (formik.values.doctorNotes !== initialDoctorNotes) {
      setIsDoctorNotesChanged(true);
    } else {
      setIsDoctorNotesChanged(false);
    }
  }, [formik.values.doctorNotes, initialDoctorNotes]);

  return (
    <form className="w-100" onSubmit={formik.handleSubmit}>
      <div className="row">
        <div className="col-sm-2">
          <Label title="Ticket Number:" className="gray small" />
        </div>
        <div className="col-sm-5">
          <ICInput
            id="ticketNo"
            name="ticketNo"
            label=""
            placeholder="First"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.ticketNo}
            disabled
            error={
              formik.touched.ticketNo && formik.errors.ticketNo ? true : false
            }
            helperText={
              formik.touched.ticketNo && formik.errors.ticketNo
                ? formik.errors.ticketNo
                : ""
            }
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-2">
          <Label title="Date Received:" className="gray small" />
        </div>
        <div className="col-sm-5">
          <ICInput
            id="dateReceived"
            name="dateReceived"
            label=""
            placeholder="Date Received"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.dateReceived}
            disabled
            error={
              formik.touched.dateReceived && formik.errors.dateReceived
                ? true
                : false
            }
            helperText={
              formik.touched.dateReceived && formik.errors.dateReceived
                ? formik.errors.dateReceived
                : ""
            }
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-2">
          <Label title="Doctor:" className="gray small" />
        </div>
        <div className="col-sm-5">
          <ICInput
            id="doctorName"
            name="doctorName"
            label=""
            placeholder="Doctor Name"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.doctorName}
            disabled
            error={
              formik.touched.doctorName && formik.errors.doctorName
                ? true
                : false
            }
            helperText={
              formik.touched.doctorName && formik.errors.doctorName
                ? formik.errors.doctorName
                : ""
            }
          />
        </div>
        <div className="col-sm-1">
          <i
            className="fas fa-file cursor-point fa-2x cursor-pointer insta-link-orange"
            onClick={() => setAccessLogModelDoctor(true)}
          ></i>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-2">
          <Label title="Patient:" className="gray small" />
        </div>
        <div className="col-sm-5" onClick={goToPatientPMSPortal}>
          <Label
            className="muted-uin-link m-0"
            title={formik.values.patientName}
          />
        </div>
        <div className="col-sm-1">
          <i
            className="fas fa-file cursor-point fa-2x cursor-pointer insta-link-orange"
            onClick={() => setAccessLogModelPatient(true)}
          ></i>
        </div>
      </div>

      <div className="w-100 border-bottom"></div>

      <div className="row mt-3">
        <div className="col-sm-2">
          <Label title="Ticket Status:" className="gray small" />
        </div>
        <div className="col-sm-5">
          <ICInput
            id="ticketStatus"
            name="ticketStatus"
            label=""
            placeholder="Doctor Name"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.ticketStatus}
            disabled
            error={
              formik.touched.ticketStatus && formik.errors.ticketStatus
                ? true
                : false
            }
            helperText={
              formik.touched.ticketStatus && formik.errors.ticketStatus
                ? formik.errors.ticketStatus
                : ""
            }
          />
        </div>
        {props.ticketData?.status === "ON_HOLD" && (
          <div
            className={formik.values.onHoldDate !== "" ? "col-sm-3" : "d-none"}
          >
            <ICInput
              id="onHoldDate"
              name="onHoldDate"
              label=""
              placeholder="Doctor Name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.onHoldDate}
              disabled
              error={
                formik.touched.onHoldDate && formik.errors.onHoldDate
                  ? true
                  : false
              }
              helperText={
                formik.touched.onHoldDate && formik.errors.onHoldDate
                  ? formik.errors.onHoldDate
                  : ""
              }
            />
          </div>
        )}
      </div>

      <div className="row mt-3">
        <div className="col-sm-2">
          <Label title="Responsible:" className="gray small" />
        </div>
        <div className="col-sm-5">
          <ICInput
            id="responsiblePerson"
            name="responsiblePerson"
            label=""
            placeholder="Responsible Person"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.responsiblePerson}
            disabled
            error={
              formik.touched.responsiblePerson &&
                formik.errors.responsiblePerson
                ? true
                : false
            }
            helperText={
              formik.touched.responsiblePerson &&
                formik.errors.responsiblePerson
                ? formik.errors.responsiblePerson
                : ""
            }
          />
        </div>
      </div>

      <div className="w-100 border-bottom"></div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Ticket Details" className="gray w-100 secondary-font"
          />
        </div>

        <div className="col-sm-2">
          <Label title="Subject:" className="gray small" />
        </div>
        <div className="col-sm-5">
          <ICInput
            id="ticketSubject"
            name="ticketSubject"
            label=""
            placeholder="Subject"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.ticketSubject}
            disabled
            error={
              formik.touched.ticketSubject && formik.errors.ticketSubject
                ? true
                : false
            }
            helperText={
              formik.touched.ticketSubject && formik.errors.ticketSubject
                ? formik.errors.ticketSubject
                : ""
            }
          />
        </div>
      </div>

      {/* <div className="row mt-3">
        <div className="col-sm-2">
          <Label title="Message:" className="gray small" />
        </div>
        <div className="col-sm-10">
          <ICInput
            id="notes"
            name="notes"
            label=""
            className="text-area dynamic-textarea"
            placeholder="Notes"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.notes}
            multiline
            disabled
            error={formik.touched.notes && formik.errors.notes ? true : false}
            helperText={
              formik.touched.notes && formik.errors.notes
                ? formik.errors.notes
                : ""
            }
          />
        </div>
      </div> */}


      <div className="row mt-3">
        <div className="col-sm-2">
          <Label title="Notes:" className="gray small" />
        </div>
        <div className="col-sm-10">
          {fields.map((note, index) => (
            <>
              <div className="mb-2">
                <TextField
                  id={`notes-${note.id}`}
                  name={`notes-${note.id}`}
                  label=""
                  className="text-area dynamic-note-textarea"
                  placeholder="Notes"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={note.message}
                  multiline
                  disabled
                  fullWidth
                />
              </div>
              {
                note.message && (
                  <div style={{ marginBottom: "10px" }} className="fa-sm"> {momentTz(note.createdAt).tz("Australia/Brisbane").format('dddd, Do MMM YYYY h:mmA')} AEST by {note.adminName}</div>
                )
              }
            </>
          ))}
        </div>
      </div>

      <div className="form-group row mt-3">
        <Label title="Tests Requested:" className="small col-sm-2" />
        <div className="col-sm-10">
          <div
            style={{ border: "2px solid #f5ab35", borderRadius: "5px" }}
            className="d-flex flex-row flex-wrap"
          >
            {formik.values.requestedTests &&
              formik.values.requestedTests.length > 0
              ? formik.values.requestedTests.map((tag, index) => (
                <div className="tag"
                  key={index}
                >
                  {tag}&nbsp;
                </div>
              ))
              : <p className="p-1">No tests here</p>}
          </div>
        </div>
      </div>

      <div className="form-group row">
        <Label title="Results Received:" className="small col-sm-2" />
        <div className="col-sm-10">
          <div
            style={{ border: "2px solid #f5ab35", borderRadius: "5px" }}
            className="d-flex flex-row flex-wrap"
          >
            {formik.values.resultsReceived &&
              formik.values.resultsReceived.length > 0
              ? formik.values.resultsReceived.map((tag, index) => (
                <div
                  className="tag"
                  key={index}
                >
                  {tag}&nbsp;
                </div>

              ))
              : <p className="p-1">No tests here</p>}
          </div>
        </div>
      </div>

      <div className="form-group row">
        <Label title="Tests Refused:" className="small col-sm-2" />
        <div className="col-sm-10">
          <div
            style={{ border: "2px solid #f5ab35", borderRadius: "5px" }}
            className="d-flex flex-row flex-wrap "
          >
            {formik.values.refusedTests &&
              formik.values.refusedTests.length > 0
              ? formik.values.refusedTests.map((tag, index) => (
                <div
                  className="tag"
                  key={index}
                >
                  {tag}&nbsp;
                </div>
              ))
              : <p className="p-1">No tests here</p>}
          </div>
        </div>
      </div>

      {/* <div className="row mt-3">
        <div className="col-sm-2">
          <Label title="Doctor Notes:" className="small" />
        </div>
        <div className="col-sm-10">
          <ICInput
            id="doctorNotes"
            name="doctorNotes"
            label=""
            className="text-area dynamic-textarea"
            placeholder="Doctor Notes..."
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.doctorNotes}
            multiline
            error={
              formik.touched.doctorNotes && formik.errors.doctorNotes
                ? true
                : false
            }
            helperText={
              formik.touched.doctorNotes && formik.errors.doctorNotes
                ? formik.errors.doctorNotes
                : ""
            }
          />
          {props.ticketData && props.ticketData.doctorNotes && props.ticketData.doctorNotesUpdatedAt && (
            <p style={{ color: 'gray' }}>
              {momentTz(props.ticketData.doctorNotesUpdatedAt)
                .tz("Australia/Brisbane")
                .format('dddd, Do MMM YYYY h:mmA')} AEST by
              {" Dr. " + props.userData.firstName + " " + props.userData.lastName}
            </p>
          )}
          <div className="row ml-2 d-flex align-items-center custom-chk-lbl">
            <div className="col-sm-8">
              <ICCheckbox
                style={{ padding: 0, paddingRight: "5px" }}
                name="NilActionRequired"
                value={nilActionRequired}
                onChange={() => handleCheckboxChange("NilActionRequired")}
                inputProps={{ "aria-label": "Nil Action Required" }}
                label="Nil Action Required"
              />
              <ICCheckbox
                style={{ padding: 0 }}
                name="FollowUpRequired"
                value={followUpRequired}
                onChange={() => handleCheckboxChange("FollowUpRequired")}
                inputProps={{ "aria-label": "Follow-Up Required" }}
                label="Follow-Up Required"
              />
            </div>
            <div className="col-sm-4">
              <div className="d-flex align-items-center" style={{ maxWidth: '100% !important', float: "right" }}>
                <img
                  alt="Medical Info"
                  src={InfoIcon} className="p-1 prev-prescribe-info-edit insta-link-gray"
                  onMouseEnter={(e) => setAnchorElement(e.target)}
                />
                {anchorElement && <Popover disableRestoreFocus anchorOrigin={{
                  vertical: "top",
                  horizontal: "center"
                }} transformOrigin={{
                  vertical: "top",
                  horizontal: "center"
                }} anchorEl={anchorElement} open={anchorElement} disablePortal>
                  <div onPointerLeave={() => setAnchorElement(null)}>
                    Notify Support Team of my notes as this <br />
                    request requires additional communication <br />
                    with the patient outside the standard action <br />
                    taken when there is "Follow-Up Required" <br />
                    or "Nil Action Required"
                  </div>
                </Popover>}
                <Button
                  disabled={disabled}
                  className={className}
                  title={title}
                  type="button"
                  onClick={() => handleNotifyDoctor(formik, title)}
                />
                <i
                  disabled={disableButton || props.ticketData && props.ticketData.status == "DOCTOR_ACTION"}
                  className={props.ticketData && props.ticketData.status == "ADMIN_ACTION" ? "ml-1 fas fa-file cursor-point fa-2x cursor-pointer insta-link-green" : (disableButton || props.ticketData && props.ticketData.status == "DOCTOR_ACTION" ? "ml-1 fas fa-file cursor-point fa-2x cursor-pointer insta-link-gray" : "ml-1 fas fa-file cursor-point fa-2x cursor-pointer insta-link-orange")}
                  onClick={() => setNotifyDoctorModel(true)}
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="row mt-3">
        <div className="col-sm-2">
          <Label title="Doctor Notes:" className="small" />
        </div>
        <div className="col-sm-10">
          {formik.values.doctorNotes.map((field, index) => {
            console.log(field)
            const { disabled, className, title } = getButtonProperties(
              field.status,
              disableButton[field.id]
            );
            return (
              <>
                <ICInput
                  id={field.id}
                  name={field.id}
                  label=""
                  className="text-area dynamic-textarea"
                  placeholder="Doctor Notes..."
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={field.note}
                  disabled={true}
                  // value={formik.values.doctorNotes.notes || ""}
                  multiline
                // error={
                //   formik.touched.doctorNotes && formik.errors.doctorNotes
                //     ? true
                //     : false
                // }
                // helperText={
                //   formik.touched.doctorNotes && formik.errors.doctorNotes
                //     ? formik.errors.doctorNotes
                //     : ""
                // }
                />
                <div className="col-sm-12 d-flex fa-sm mt-2"> {momentTz(field.createdAt).tz("Australia/Brisbane").format('dddd, Do MMM YYYY h:mmA')} AEST by {field.doctorName}</div>
                <div className="row ml-2 d-flex align-items-center custom-chk-lbl">
                  <div className="col-sm-8">
                    {doctorNotes && field.note && (
                      <>
                        <ICCheckbox
                          style={{ padding: 0, paddingRight: "5px" }}
                          value={field.note.includes("Nil Action Required")}
                          disabled
                          name={`doctorNotes[${index}].status`} // Use 'status' field for checkboxes
                          onChange={() => handleCheckboxChange(index, "NilActionRequired")}
                          inputProps={{ "aria-label": "Nil Action Required" }}
                          label="Nil Action Required"
                        />
                        <ICCheckbox
                          style={{ padding: 0 }}
                          value={field.note.includes("Follow-Up Required")}
                          name={`doctorNotes[${index}].status`}
                          disabled
                          onChange={() => handleCheckboxChange(index, "FollowUpRequired")}
                          inputProps={{ "aria-label": "Follow-Up Required" }}
                          label="Follow-Up Required"
                        />
                      </>
                    )}
                  </div>
                  <div className="col-sm-4">
                    <div className="d-flex align-items-center" style={{ maxWidth: '100% !important', float: "right" }}>
                      <img
                        alt="Medical Info"
                        src={InfoIcon} className="p-1 prev-prescribe-info-edit insta-link-gray"
                        onMouseEnter={(e) => setAnchorElement(e.target)}
                      // style={{ width: "22px", height: "22px", marginTop: "4px" }}
                      />
                      {anchorElement && <Popover disableRestoreFocus anchorOrigin={{
                        vertical: "top",
                        horizontal: "center"
                      }} transformOrigin={{
                        vertical: "top",
                        horizontal: "center"
                      }} anchorEl={anchorElement} open={anchorElement} disablePortal>
                        <div onPointerLeave={() => setAnchorElement(null)}>


                          {/* <MedicalInfo patientId={assessmentData.patientId._id} className="col-sm-12 medicalInfo p-4" /> */}
                          Notify Support Team of my notes as this <br />
                          request requires additional communication <br />
                          with the patient outside the standard action <br />
                          taken when there is "Follow-Up Required" <br />
                          or "Nil Action Required"
                        </div>
                      </Popover>}
                      <Button
                        disabled={field.status == "ADMIN_ACTION_REQUIRED" || field.status == "RESOLVED" ? true : disabled}
                        className={className}
                        title={title}
                        type="button"
                        onClick={() => handleadminaction(field.note, field.id, title)}
                      />
                      <i
                        disabled={disableButton || field.status == "DOCTOR_ACTION_REQUIRED"}
                        className={"ml-1 fas fa-file cursor-point fa-2x cursor-pointer insta-link-orange"}
                        onClick={() => handleActionLogs(field.actionLogs)}
                      ></i>
                    </div>
                  </div>
                </div>
              </>
            )
          }
          )}
          {
            ((formik.values.doctorNotes && formik.values.doctorNotes[formik.values.doctorNotes.length - 1] && formik.values.doctorNotes[formik.values.doctorNotes.length - 1].status === "RESOLVED") || (!formik.values.doctorNotes.length)) && (
              <>
                <ICInput
                  id="doctorNotes"
                  name="doctorNotes"
                  label=""
                  className="text-area dynamic-textarea mt-2"
                  disabled={formik.values.doctorNotes[formik.values.doctorNotes.length - 1] && formik.values.doctorNotes[formik.values.doctorNotes.length - 1].status !== "RESOLVED"}
                  placeholder="Doctor Notes..."
                  onChange={handleChangenotes}
                  // value={message}
                  value={formik.values.message}
                  multiline
                />

                <div className="row ml-2 d-flex align-items-center custom-chk-lbl">
                  <div className="col-sm-8">
                    <ICCheckbox
                      style={{ padding: 0, paddingRight: "5px" }}
                      name="NilActionRequired"
                      value={nilActionRequired}
                      onChange={() => handleCheckboxChange_1("NilActionRequired")}
                      inputProps={{ "aria-label": "Nil Action Required" }}
                      label="Nil Action Required"
                    />
                    <ICCheckbox
                      style={{ padding: 0 }}
                      name="FollowUpRequired"
                      value={followUpRequired}
                      onChange={() => handleCheckboxChange_1("FollowUpRequired")}
                      inputProps={{ "aria-label": "Follow-Up Required" }}
                      label="Follow-Up Required"
                    />
                  </div>
                  <div className="col-sm-4">
                    <div className="d-flex align-items-center" style={{ maxWidth: '100% !important', float: "right" }}>
                      <Button
                        disabled={formik.values.doctorNotes[formik.values.doctorNotes.length - 1] && formik.values.doctorNotes[formik.values.doctorNotes.length - 1].status !== "RESOLVED"}
                        title={"Add Note"}
                        type="button"
                        onClick={handleAddNotes}
                      />
                    </div>
                  </div>
                </div>
              </>
            )
          }
        </div>
      </div>

      {/*<div className="w-100 border-bottom mt-2"></div>*/}

      {/*
       * No Attachment Found block & Attachment listing block as per below, however,
       * We have removed this functionality But the code is as below
       */}

      {/* <div className="row mt-3">
        <div className="col-sm-2">
          <Label title="Attachments:" className="gray small" />
        </div>
        <div className="col-sm-12">
          {
            attachmentFile.map((values, index) => {
              if (!values.url.includes(".pdf")) {
                return (
                  <a key={index} href={values.url} target="_blank">
                    <img
                      src={values.url}
                      alt="ticket-attachment"
                      className="attachment-images img-thumbnail"
                    />
                  </a>)
              }
            })
          }
        </div>

        <div className="col-sm-12 mt-2">
          {
            attachmentFile.map((values, index) => {
              if (values.url.includes(".pdf")) {
                return (
                  <div
                    className="consult-note-dropdown-group m-1 ml-0"
                    key={index}
                  >
                    <ButtonDropdown direction="down" className="w-100">
                      <Link
                        title="PDF"
                        href={values.url}
                        target="_blank"
                        className="consult-note-pdf-btn font-12"
                      />
                      <ICButton
                        id="caret"
                        title={"Document " + (index + 1)}
                        className="gray small pl-2 pr-0 m-0 text-left consult-note-btn font-12"
                        clickEvent={() => {
                          window.open(values.url, "_blank");
                        }}
                      />
                    </ButtonDropdown>
                  </div>
                )
              }
            })
          }
        </div>

        <div className="col-sm-12 mt-2">
          {attachmentFile.length === 0 ? (
            <Label className="" title="No attachment found" />
          ) : (
              ''
            )}
        </div>
      </div> */}

      <div className="row mt-3">
        <div className="col-sm-12 text-center">
          {/* <ICButton type="Submit" title="Save" className="mr-2" /> */}
          <ICButton className='gray-outline' onClick={() => { history.push(appRoutes.tickets); }} type="button" title="Back to Tickets" />
        </div>
      </div>

      <CustomModal
        useOneButton={true}
        okayText="Okay"
        cancelText="OKAY"
        title={<div style={{ height: "25px" }}></div>}
        openModal={notifyDoctorSuccessModel}
        cancelEvent={closeNotifyDoctorModel}
        okayEvent={closeNotifyDoctorModel}
        modalBodyContent={notifyDoctorModelBody}
      />
      <Model
        openModal={accessLogModelDoctor}
        modalBodyContent={doctorNotifiedModelBody}
        okayText="Okay"
        cancelText="Okay"
        title={"Doctor Notified"}
        useOneButton={true}
        okayEvent={closeAccessLogModel}
        cancelEvent={closeAccessLogModel}
      />
      <Model
        openModal={notifyDoctorModel}
        modalBodyContent={doctorActionModelBody}
        okayText="Okay"
        cancelText="Okay"
        title={"Action Required Log"}
        useOneButton={true}
        okayEvent={closeNotifyDoctorModel}
        cancelEvent={closeNotifyDoctorModel}
      />
      <Model
        openModal={accessLogModelPatient}
        modalBodyContent={patientNotifiedModelBody}
        okayText="Okay"
        cancelText="Okay"
        title={"Patient Notified"}
        useOneButton={true}
        okayEvent={closeAccessLogModel}
        cancelEvent={closeAccessLogModel}
      />
    </form>
  );
};

export default TicketsUpdateForm;

TicketsUpdateForm.defaultProps = {
  serverErrorMsg: "" // not used but keeping it
};

TicketsUpdateForm.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string // not used but keeping it
};
